import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import PrivacyPolicyModal from './PrivacyPolicyModal'
import TermsModal        from './TermsModal'
import ImpressumModal    from './ImpressumModal'
import { fetchCompanySetting } from '../utils/api'

function Footer({ showCompanyName }) {
  const [showPrivacy,    setShowPrivacy]    = useState(false)
  const [showTerms,      setShowTerms]      = useState(false)
  const [showImpressum,  setShowImpressum]  = useState(false)
  const [companyName,    setCompanyName]    = useState('')
  const location = useLocation()

  useEffect(() => {
    // Paths where we never want to show the company name:
    const hideOnPaths = [
      '/login',
      '/signup',
      '/forgot-password',
      '/reset-password',
    ]
    const shouldHide = hideOnPaths.includes(location.pathname)

    async function loadCompanyName() {
      try {
        const settings = await fetchCompanySetting()
        setCompanyName(settings.company_name || '')
      } catch (error) {
        console.error('Failed to load company name:', error)
        setCompanyName('')
      }
    }

    // Clear any existing name if on a public path OR if user isn’t logged in
    if (shouldHide || !showCompanyName) {
      setCompanyName('')
    } else {
      // Otherwise, fetch it once
      loadCompanyName()
    }
  }, [location.pathname, showCompanyName])

  return (
    <>
      <footer className="app-footer bg-light py-3 mt-5 border-top text-dark">
        <div className="app-footer_container d-flex flex-column align-items-center justify-content-center text-center gap-2 small">
          <div className="app-footer_credits">
            © {new Date().getFullYear()}
            {companyName && ` ${companyName}`}
          </div>
          <div className="app-footer_links d-flex gap-3">
            <button
              className="app-footer_link-btn app-footer_privacy-btn btn btn-link p-0 text-primary"
              onClick={() => setShowPrivacy(true)}
            >
              Privacy Policy
            </button>
            <button
              className="app-footer_link-btn app-footer_terms-btn btn btn-link p-0 text-primary"
              onClick={() => setShowTerms(true)}
            >
              Terms of Use
            </button>
            <button
              className="app-footer_link-btn app-footer_impressum-btn btn btn-link p-0 text-primary"
              onClick={() => setShowImpressum(true)}
            >
              Impressum
            </button>
          </div>
        </div>
      </footer>

      <PrivacyPolicyModal
        isOpen={showPrivacy}
        onClose={() => setShowPrivacy(false)}
      />
      <TermsModal
        isOpen={showTerms}
        onClose={() => setShowTerms(false)}
      />
      <ImpressumModal
        isOpen={showImpressum}
        onClose={() => setShowImpressum(false)}
      />
    </>
  )
}

export default Footer
